const DAYS_OF_WEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const mapHeaderData = (weekDays: string[]) => {
  const headerData = DAYS_OF_WEEK.map((data, index) => {
    return { title: data, new_date: weekDays[index] };
  });
  headerData.unshift({ title: 'ASSIGNMENT', new_date: null });
  headerData.push({ title: 'WEEKLY HOURS', new_date: null });

  return headerData;
};
